<div
  class="slider {{ colorfulSlideBar ? 'slider-colorful' : 'slider-primary' }}"
>
  <div class="custom-slider">
    <div *ngIf="sliderData">
      <p class="p4-semibold text-secondary">
        {{ sliderData.title | translate }}
      </p>
    </div>
    <ngx-slider
      [(value)]="value"
      [options]="options"
      [formControl]="control"
      (userChangeEnd)="userChangeEnd()"
    ></ngx-slider>
    <div>
      <p
        *ngIf="sliderData.lowValue"
        class="r7-regular text-muted d-inline-flex gml-32 gml-sm-48"
      >
        {{ sliderData.lowValue | translate }}
      </p>
      <p
        *ngIf="sliderData.highValue"
        class="r7-regular text-muted float-right gmr-32 gmr-sm-48"
      >
        {{ sliderData.highValue | translate }}
      </p>
    </div>
  </div>
</div>
